import { faPlus, faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, Fragment } from "react";
import { useHistory } from "react-router";
import AppHeader from "../../../../Layout/AppHeader";
import AppSidebar from "../../../../Layout/AppSidebar";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import QueryService from "../../../../services/QueryService";
import swal from "sweetalert";
import GetStudentService from "../../../../services/SchoolIT/GetStudentService";
import "../../../admin/StudentProgress/StudentProgress.css";
import "../GoalCriteriaOrSetup.css";

const ExpressionModal = ({
  isOpen,
  closeHandler,
  data,
  selectedOptionforModal,
  optionValueForModal,
  setOptionValueForModal,
  saveMethodForModal
}) => {

  const handleInputChange = (e, index) => {
    optionValueForModal[index].map_val = e.target.value;
    setOptionValueForModal([...optionValueForModal]);
  };

  return (
    <Fragment>
      <Modal isOpen={isOpen}>
        <ModalHeader>
          <p>{data?.criteria}</p>
        </ModalHeader>
        <ModalBody>
          <div
            style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)" }}>

            <div>
              <p>Configured Values</p>
              {selectedOptionforModal?.map((item, _index) =>
              <div style={{ margin: "15px 0" }}>
                  <input type="text" value={item.name} disabled />
                </div>
              )}
            </div>
            <div>
              <p>Mapped Values</p>
              {selectedOptionforModal?.map((item, index) =>
              <div style={{ margin: "15px 0" }}>
                  <input
                  type="text"
                  onChange={(e) => handleInputChange(e, index)}
                  value={optionValueForModal[index]?.map_val} />

                </div>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button onClick={saveMethodForModal} className="admin-ccplus-btn primary">
            <FontAwesomeIcon icon={faSave} style={{ margin: "0 3px" }} />
            Save
          </button>
          <button className="cancel-modal-button" onClick={closeHandler}>
            <FontAwesomeIcon icon={faTimes} style={{ margin: "0 3px" }} />
            Cancel
          </button>
        </ModalFooter>
      </Modal>
    </Fragment>);

};

const MapCollege = () => {
  const [, setConfigureListData] = useState();
  const [user] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );
  const [dataSource, setDataSource] = useState();
  const [criteria, setCriteria] = useState([]);
  const [dataSourceColumn, setDataSourceColumn] = useState([]);
  const [operatorData, setOperatorData] = useState([]);
  const [expressionCriteria, setExpressionCriteria] = useState([]);
  const [openExpressionModal, setOpenExpressionModal] = useState(false);
  const [expressionModalData, setExpressionModalData] = useState();
  const [ethnicityOption, setEthnicityOption] = useState([]);
  const [zipOption, setZipOption] = useState([]);
  const [genderOption, setGenderOption] = useState([]);
  const [selectedOptionforModal, setSelectedOptionforModal] = useState();
  const [optionValueForModal, setOptionValueForModal] = useState([]);
  const history = useHistory();

  const expressionModalHandler = (criteria) => {
    setOpenExpressionModal(true);
    setExpressionModalData(criteria);
  };

  const saveCollegeCriteria = () => {
    if (criteria[0] !== null) {
      criteria.unshift(null);
    }
    let cr = criteria;
    let obj = {
      map_values: cr,
      school_id: user?.school_id
    };
    GetStudentService.saveMapCollege(obj)
    .then((_data) => {
      swal({
        text: `Saved Successfully!`,
        icon: "success",
        buttons: {
          OK: true
        },
        closeOnClickOutside: false
      });
    })
    .catch(() => {});
  };

  useEffect(() => {
    if (expressionModalData) {
      if (expressionModalData?.criteria === "Gender") {
        setSelectedOptionforModal(genderOption);
      } else if (expressionModalData?.criteria === "Ethnicity") {
        setSelectedOptionforModal(ethnicityOption);
      } else if (expressionModalData?.criteria === "Zip Code") {
        setSelectedOptionforModal(zipOption);
      }
    }
  }, [expressionModalData]);

  useEffect(() => {
    let array = [];
    selectedOptionforModal?.map((item, _index) => {
      let obj = {};
      obj["config_val"] = item?.name;
      obj["criteria_id"] = item?.id;
      obj["exp_id"] = "";
      obj["map_id"] = expressionModalData?.id;
      obj["map_val"] = "";
      array.push(obj);
    });
    setOptionValueForModal(array);
  }, [expressionModalData && selectedOptionforModal]);

  const getGenderOption = () => {
    QueryService.getGender()
    .then((data) => {
      setGenderOption(data.data.objects);
    })
    .catch(() => {});
  };

  const getEthnicityOption = () => {
    QueryService.getEthnicity()
    .then((data) => {
      setEthnicityOption(data.data.objects);
    })
    .catch(() => {});
  };

  const getZipOption = () => {
    QueryService.getEthnicity()
    .then((data) => {
      setZipOption(data.data.objects);
    })
    .catch(() => {});
  };

  const getArithemeticOperator = () => {
    GetStudentService.getArithemeticOperator()
    .then((data) => {
      setOperatorData(data?.data?.objects);
    })
    .catch(() => {});
  };

  const getDataSourceCol = (value) => {
    GetStudentService.getDataSrcCol(value)
    .then((data) => {
      setDataSourceColumn(data?.data?.objects);
    })
    .catch(() => {});
  };

  const criteriaNameHandler = (e, index) => {
    criteria[index].criteria = e.target.value;
    setCriteria([...criteria]);
  };

  const createCriteria = (res) => {
    let array = [];
    res.map((item, _index) => {
      let obj = {};
      obj["datasource"] = parseInt(item?.datasource);
      obj["datacolumn"] = parseInt(item?.datacolumn);
      obj["criteria"] = item?.name;
      obj["criteria_id"] = parseInt(item?.id);
      obj["expression"] = item?.expression;
      obj["is_criteriaexpression"] = item?.is_criteriaexpression;
      obj["id"] = parseInt(item?.criteriamap_id);
      obj["modal_show"] = item?.is_criteriaexpression === true ? true : false;
      array.push(obj);
      if (item?.datasource) {
        getDataSourceCol(item?.datasource);
      }
    });
    setCriteria(array);
  };

  const getConfigureList = () => {
    let obj = {
      list_name: "query_criteria",
      school: user?.school_id
    };
    GetStudentService.getConfigureMapList(obj)
    .then((data) => {
      setConfigureListData(data?.data);
      createCriteria(data?.data);
    })
    .catch(() => {});
  };

  const getDataSource = () => {
    GetStudentService.getDataSrc(user?.school_id)
    .then((data) => {
      setDataSource(data?.data?.objects);
    })
    .catch(() => {});
  };

  const dataSourceHandler = (e, index) => {
    criteria[index].datasource = parseInt(e.target.value);
    getDataSourceCol(parseInt(e.target.value));
    setCriteria([...criteria]);
  };

  const dataSourceColumnHandler = (e, index) => {
    criteria[index].datacolumn = parseInt(e.target.value);
    setCriteria([...criteria]);
  };

  const handleExpressionCheckBox = (index) => {
    // if(index==3) criteria[index].modal_show = true
    criteria[index].is_criteriaexpression =
    !criteria[index].is_criteriaexpression;
    setCriteria([...criteria]);
  };

  const addNewExpression = (criteriaIndex) => {
    let newitem = expressionCriteria.length + 1;
    let array = [];
    let obj = {
      newitem: newitem,
      operator: "",
      val: "",
      id: ""
    };
    array.push(obj);
    criteria[criteriaIndex].expression.push(obj);
    setExpressionCriteria([...expressionCriteria, ...array]);
    setCriteria([...criteria]);
  };

  const saveMethodForModal = () => {
    let obj = {
      map_exp: optionValueForModal
    };
    GetStudentService.saveModalOption(obj)
    .then((_data) => {
      setOpenExpressionModal(false);
    })
    .catch(() => {});
  };

  useEffect(() => {
    getConfigureList();
    getDataSource();
    getArithemeticOperator();
    getGenderOption();
    getZipOption();
    getEthnicityOption();
  }, []);

  const handleOperatorChange = (i, e, criteriaIndex) => {
    expressionCriteria[i].operator = e.target.value;
    criteria[criteriaIndex].expression[i].operator = parseInt(e.target.value);
    setCriteria([...criteria]);
  };

  const handleValueChange = (index, event, criteriaIndex) => {
    expressionCriteria[index].val = event.target.value;
    criteria[criteriaIndex].expression[index].val = event.target.value;
    setCriteria([...criteria]);
  };

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="admin-ccplus-page">
            <div className="admin-ccplus-header">
              <div>
                <h1 className="admin-ccplus-title">Map School College Data</h1>
                <p className="admin-ccplus-subtitle">
                  Map college criteria to your school data sources
                </p>
              </div>
              <div className="admin-ccplus-header-actions">
                <button
                  type="button"
                  onClick={() => history.push("/school_it/ccplus")}
                  className="admin-ccplus-btn ghost toolbar">

                  Back
                </button>
              </div>
            </div>

            <div className="admin-ccplus-form-card school-it-map-form">
              <p className="school-it-map-section-title">Criterias</p>
              <div className="school-it-map-list">
                {criteria?.map((item, index) =>
                <div key={index} className="school-it-map-row">
                    <input
                    type="text"
                    className="admin-course-set-input school-it-map-criteria-input"
                    onChange={(e) => criteriaNameHandler(e, index)}
                    value={criteria[index].criteria} />

                    <select
                    className="admin-course-set-input school-it-map-select"
                    value={criteria[index].datasource}
                    onChange={(e) => dataSourceHandler(e, index)}>

                      <option>Select Data Source</option>
                      {dataSource?.map((dsItem) =>
                    <option key={dsItem?.id} value={parseInt(dsItem?.id)}>
                          {dsItem?.name}
                        </option>
                    )}
                    </select>

                    <select
                    className="admin-course-set-input school-it-map-select"
                    value={criteria[index].datacolumn}
                    onChange={(e) => dataSourceColumnHandler(e, index)}>

                      <option>Select Data Column</option>
                      {dataSourceColumn?.map((colItem) => {
                      if (criteria[index].datasource)
                      return (
                        <option
                          key={colItem?.id}
                          value={parseInt(colItem?.id)}>

                              {colItem?.column_name}
                            </option>);

                    })}
                    </select>

                    <div className="school-it-map-expression">
                      <label className="school-it-map-check">
                        <input
                        type="checkbox"
                        value={criteria[index].is_criteriaexpression}
                        checked={criteria[index].is_criteriaexpression}
                        onChange={() => handleExpressionCheckBox(index)} />

                        Add Expression
                      </label>
                      {criteria[index].is_criteriaexpression === true &&
                    criteria[index].modal_show === true &&
                    <button
                      type="button"
                      className="admin-ccplus-btn secondary toolbar"
                      onClick={() =>
                      expressionModalHandler(criteria[index])}>

                      {`${criteria[index].criteria} map`}</button>}

                      {criteria[index].is_criteriaexpression &&
                    criteria[index].modal_show === false &&
                    <div className="school-it-map-expression-fields">
                            {expressionCriteria &&
                      expressionCriteria.length > 0 &&
                      expressionCriteria.map((expItem, i) =>
                      <div key={i} className="school-it-map-expr-row">
                                  <select
                          className="admin-course-set-input school-it-map-select"
                          value={expressionCriteria[i].operator}
                          onChange={(e) =>
                          handleOperatorChange(i, e, index)}>


                                    <option value={null} disabled>
                                      Select Operator
                                    </option>
                                    {operatorData?.map((opItem) =>
                          <option
                            key={opItem?.id}
                            value={parseInt(opItem?.id)}>

                                        {opItem.operator}
                                      </option>
                          )}
                                  </select>
                                  <input
                          type="text"
                          className="admin-course-set-input school-it-map-value-input"
                          onChange={(e) =>
                          handleValueChange(i, e, index)}

                          value={expressionCriteria[i].val} />

                                </div>
                      )}
                            <button
                        type="button"
                        className="admin-ccplus-btn secondary toolbar"
                        onClick={() => addNewExpression(index)}>

                              <FontAwesomeIcon icon={faPlus} />
                            </button>
                          </div>}

                    </div>
                  </div>
                )}
              </div>

              <div className="admin-ccplus-form-actions">
                <button
                  type="button"
                  className="admin-ccplus-btn primary"
                  onClick={saveCollegeCriteria}>

                  <FontAwesomeIcon icon={faSave} />
                  Save
                </button>
                <button
                  type="button"
                  className="admin-ccplus-btn ghost"
                  onClick={() => history.push("/school_it/ccplus")}>

                  <FontAwesomeIcon icon={faTimes} />
                  Cancel
                </button>
              </div>
            </div>
          </div>

          {openExpressionModal &&
          <ExpressionModal
            isOpen={openExpressionModal}
            closeHandler={() => setOpenExpressionModal(false)}
            data={expressionModalData}
            selectedOptionforModal={selectedOptionforModal}
            optionValueForModal={optionValueForModal}
            setOptionValueForModal={setOptionValueForModal}
            saveMethodForModal={saveMethodForModal} />}


        </div>
      </div>
    </Fragment>);

};

export default MapCollege;